import React from 'react';
import styled from 'styled-components';
import JwtStore from "../../flux/JwtStore";
import ConfidentialLabel from '../ConfidentialLabel';
import FurSpecialistLabel from '../FurSpecialistLabel';
import OutletOnlyLabel from "../OutletOnlyLabel";

export default function ThemeLabelContainer({ theme, width = null }) {
  const labels = [];

  if (theme.confidential) {
    labels.push(<ConfidentialLabel key="confidential" />);
  }

  if (theme.furSpecialist) {
    labels.push(<FurSpecialistLabel key="fur_specialist" />);
  }

  if (JwtStore.hasGlobalVisibility() && theme.visibleOnlyForOutlets) {
    labels.push(<OutletOnlyLabel key="outlet_only" />)
  }

  return (
    <Container children={labels} width={width} />
  )
}

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;

  width: ${({ width }) => width};

  > div {
    position: static;
    margin-left: .125rem;
    margin-bottom: .125rem;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      // margin-bottom: 0;
    }
  }
`;
